import { render, staticRenderFns } from "./IconMinusSolid.vue?vue&type=template&id=7e49dfe0"
import script from "./IconMinusSolid.vue?vue&type=script&lang=js"
export * from "./IconMinusSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports